import React from 'react';
import { Box } from '@mui/material';
import classNames from 'classnames';
import styles from './SpotDescriptor.module.scss';

interface Option {
  name: string;
  value: boolean;
}
interface Props {
  options: Option[] | string[];
}

const MultiScale: React.FC<Props> = ({ options }) => (
  <Box
    className={classNames({
      [styles.scaleBar]: true,
      [styles.multiScaleBar]: true,
    })}
    data-testid="spot-descriptor-multi-scale"
  >
    {options.map((option) => {
      const name = typeof option === 'string' ? option : option.name;
      const value = typeof option === 'string' ? null : option.value;
      return (
        <Box
          key={`scale-item-${name}`}
          className={classNames({
            [styles.scaleBarItem]: true,
            [styles.empty]: !value,
          })}
          data-testid="spot-descriptor-multi-scale-item"
        />
      );
    })}
  </Box>
);

export default MultiScale;
